import PropTypes from 'prop-types';
import { date } from '@eti/utils';
import { DIRECTIONS, useDirection, useDateFormat } from '@eti/providers';
import { css, etiColors, mediaQueries } from '@eti/styles';
import OvernightIndicator from './TripDetailsOvernightIndicator';
import { LocationAndTimeWrapper } from './styles/tripDetailsSegment';

const airportStyles = css`
  color: ${etiColors.black};
  font-size: 0.625rem;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${mediaQueries.medium.up} {
    font-size: 0.75rem;
  }

  @media ${mediaQueries.large.up} {
    font-size: 0.875rem;
  }
`;

const cityStyles = css`
  color: ${etiColors.grayScale[10]};
  font-size: 0.625rem;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${mediaQueries.large.up} {
    font-size: 0.75rem;
  }
`;

const timestampStyles = css`
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
  position: relative;

  @media ${mediaQueries.medium.up} {
    font-size: 1.5rem;
  }

  @media ${mediaQueries.large.up} {
    font-size: 1.75rem;
  }
`;

const { LTR, RTL } = DIRECTIONS;

const TripDetailsTimeLocation = ({
  airportCode,
  airportName,
  city,
  dataTestid,
  time,
  durationInDays,
}) => {
  const { direction } = useDirection();
  const { time: dateTime } = useDateFormat();

  const AirPortNameElement = () => (
    <span data-testid={`${dataTestid}-airportName`}>{airportName}</span>
  );

  return (
    <LocationAndTimeWrapper>
      <div className={timestampStyles} data-testid={dataTestid}>
        <span>{date.format(time, dateTime)}</span>

        {durationInDays > 0 && <OvernightIndicator durationInDays={durationInDays} />}
      </div>
      <p className={airportStyles} title={airportName}>
        {direction === RTL && <AirPortNameElement />}
        <strong data-testid={`${dataTestid}-airportCode`}> {airportCode} </strong>
        {direction === LTR && <AirPortNameElement />}
      </p>
      <p className={cityStyles} data-testid={`${dataTestid}-cityName`}>
        {city}
      </p>
    </LocationAndTimeWrapper>
  );
};

TripDetailsTimeLocation.propTypes = {
  airportCode: PropTypes.string,
  airportName: PropTypes.string,
  city: PropTypes.string,
  dataTestid: PropTypes.string,
  durationInDays: PropTypes.number,
  time: PropTypes.string,
};

export default TripDetailsTimeLocation;
